<template>
  <div class="wechat-blank">

  </div>
</template>

<script>
  import WechatService from '@/io/wechat.js';

  export default {
    name: 'WechatBlank',
    mounted () {
      let code;
      let state;
      let appid;
      window.location.hash.substring(15).split('&').forEach(val => {
        let data = val.split('=');
        if (data[0] === 'code') {
          code = data[1];
        } else if (data[0] === 'state') {
          state = data[1];
        } else if (data[0] === 'appid') {
          appid = data[1];
        }
      });
      WechatService.check(code, state, appid).then(() => {
        this.$router.replace({
          path: '/choose_company'
        });
      }).catch(() => {
        this.$router.replace({
          path: '/entrance'
        });
      });
    },
  }
</script>

<style lang="less" scoped>

</style>
